<div class="grid grid-cols-12">
  <div class="col-span-12">
    <div class="mt-8 flex justify-center px-4">
      <mat-button-toggle-group
        [value]="activeRoute"
        (change)="onToggleChange($event)"
        class="flex max-w-full flex-wrap justify-center"
      >
        <mat-button-toggle value="accounts" class="w-[110px] sm:w-[120px]">
          Accounts
        </mat-button-toggle>

        <mat-button-toggle value="users" class="w-[110px] sm:w-[120px]">
          Users
        </mat-button-toggle>

        <mat-button-toggle value="sites" class="w-[110px] sm:w-[120px]">
          Sites
        </mat-button-toggle>

        <mat-button-toggle value="platforms" class="w-[110px] sm:w-[120px]">
          Platforms
        </mat-button-toggle>

        <mat-button-toggle value="posts" class="w-[110px] sm:w-[120px]">
          Posts
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
</div>